import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../index.css";
import styles from '../../style.js';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CompanyFtp from './CompanyFtp';
import CompanyMail from './CompanyMail';
import BasicPageComponent from '../BasicPageComponent';

class CompanyContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsValue:'1'
    };
  }

  tabsChange = (event,newValue) => {
    this.setState({ tabsValue: newValue });
  };

  tabsClick = (value) => {
    if(value===this.state.tabsValue)
      this.setState({ tabsValue: '1' });
  };

  render() {
    const { tabsValue} = this.state;

    let component = null;
    switch(tabsValue) {
      case "1":
        component = <CompanyFtp {...this.props}/>;
        break;
      case "2":
        component = <CompanyMail {...this.props}/>;
        break;
      default:
        component = null;
    }

    return (
      <div>
        <div style = {{display: 'flex', flexDirection: 'column'}}>
          <BasicPageComponent
          children = {
            <ScreenContainer>
              <Box sx={{ width: '100%' }}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <Box sx={{boxShadow: 'none',backgroundColor: 'none'}}>        
                      <div>
                        <Tabs className='customContactTabs' value={tabsValue} onChange={this.tabsChange} variant="scrollable" allowScrollButtonsMobile>  
                            <Tab className='customContactTab' onClick={() => this.tabsClick("1")} label={<div style={styles.tabHeader}>FTP Adres Tanımlama</div>} value="1" />                
                            <Tab className='customContactTab' onClick={() => this.tabsClick("2")} label={<div style={styles.tabHeader}>E-posta Tanımlama</div>} value="2" />                        
                        </Tabs>
                      </div>       
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      {component}
                    </div>
                  </Grid>                  
                </Grid>
              </Box>
            </ScreenContainer>
          }/> 
        </div>
    </div>
    );
  }
}

export default (CompanyContact);